import { Typography } from '@mui/material';
import type { FC } from 'react';
import { tooltipCell } from './styles';

interface NetworkStringDisplayProps {
    data: string;
    fullCell?: boolean;
}

const NetworkStringDisplay: FC<NetworkStringDisplayProps> = ({ data, fullCell }) => (
    <Typography sx={{ ...tooltipCell, ...(fullCell && { height: 1, width: 1 }) }}>{data}</Typography>
);

export default NetworkStringDisplay;
